import React from "react";
import Button from "../../components/ui/Button";
import EditText from "../../components/ui/EditText";

const ContactFormSection = ({ formData, handleInputChange, handleSubmit }) => {
  return (
    <section className="relative w-full  py-8 md:py-12 ">
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 flex flex-col xl:flex-row gap-10">
        {/* Contact Information */}
        <div className="flex flex-col gap-6 md:gap-[30px] flex-shrink-0 ">
          <ContactInfoItem
            icon="/assets/icon/callIcon.png"
            text="+91-8645888881"
          />
          <ContactInfoItem
            icon="/assets/icon/mailIcon1.png"
            text="info@utpann.in"
          />
          <ContactInfoItem
            icon="/assets/icon/locationIcon1.png"
            text="Sr. No. 2373, Sim Vistar, At & Po-Pij, Ta-Vaso, Dist, Nadiad, Gujarat 387230"
          />
        </div>

        {/* Contact Form */}
        <div className="flex-1 flex justify-center">
          <form onSubmit={handleSubmit} className="w-full max-w-[900px] ">
            {/* Add these classes to the parent container */}
            <div className="bg-black/20 backdrop-blur-md border border-white rounded-md md:rounded-[30px] p-4 md:p-8 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-[40px]">
              <div className="flex flex-col gap-4">
                <FormInput
                  label="Name"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
                <FormInput
                  label="Phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleInputChange}
                />

                <div className="pt-4 hidden md:block">
                  <Button
                    type="submit"
                    text="Submit"
                    className="hover:bg-white hover:text-[#343163] transition-colors duration-300  text-[18px] md:text-[24px] font-medium text-white font-['Parkinsans'] px-6 py-3 border border-white rounded-[30px]"
                    text_font_size="24px"
                    text_color="#ffffff"
                    border_border="1px solid #ffffff"
                    border_radius="30px"
                  />
                </div>
              </div>

              <div className="flex flex-col gap-4">
                <FormInput
                  label="Email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleInputChange}
                />
                <FormInput
                  label="City"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                />
                <div className="pt-4 block md:hidden">
                  <Button
                    type="submit"
                    text="Submit"
                    className="hover:bg-white hover:text-[#343163] transition-colors duration-300  text-[18px] md:text-[24px] font-medium text-white font-['Parkinsans'] px-6 py-3 border border-white rounded-[30px]"
                    text_font_size="24px"
                    text_color="#ffffff"
                    border_border="1px solid #ffffff"
                    border_radius="30px"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

// सहायक कॉम्पोनेंट्स (Helper Components)
const ContactInfoItem = ({ icon, text }) => (
  <div className="flex items-start gap-3 md:gap-[10px]">
    <box className="w-[40px] h-[40px] md:w-[50px] md:h-[50px] flex-shrink-0 flex justify-center items-center bg-[#000] border border-white rounded-full">
      <img src={icon} alt="icon" className="" />
    </box>
    <span className="text-[20px] md:text-[28px] font-medium md:text-white font-['Parkinsans'] flex-1 max-w-[400px]">
      {text}
    </span>
  </div>
);

const FormInput = ({ label, ...props }) => (
  <div className="flex flex-col gap-2 ">
    <label className="text-[18px] md:text-[24px] font-medium text-white font-['Parkinsans']">
      {label}
    </label>
    <EditText
      {...props}
      border_border="1 solid #ffffff"
      border_border_radius="14px"
      padding="12px"
      className="bg-transparent text-white placeholder:text-white/50 border border-white pb-4 rounded-[14px] "
    />
  </div>
);

export default ContactFormSection;
